import { observable, action, flow, set } from 'mobx';
import Stores from 'config/Stores';
import Serv from './ProtectionServ';

class ProtectionMod {
  // 协议类型：0-会员，1-店铺
  @observable type = '';

  // 协议列表
  @observable agreementList = [];

  // 协议详情
  @observable agreementDatas = {};

  // 三生文化
  @observable companyCulture = '';

  // 产品退换货管理制度
  @observable returnGoods = '';

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 查询合同协议列表
   */
  queryAgreementList = flow(function* (type, belongSystem) {
    try {
      const { data } = yield Serv.queryAgreementList({ type, belongSystem });
      if (Array.isArray(data)) {
        this.agreementList = data;
      }
    } catch (error) {}
  });

  /**
   * 获取合同协议详情
   */
  getAgreement = flow(function* (code) {
    try {
      const { data } = yield Serv.getAgreement(code);
      set(this.agreementDatas, { [data.code]: data });
      return data;
    } catch (error) {
      return null;
    }
  });

  /**
   * 获取三生文化
   */
  getCompanyCulture = flow(function* () {
    try {
      const { data } = yield Serv.getCompanyCulture();
    } catch (error) {}
  });

  /**
   * 获取产品退换货管理制度
   */
  getReturnGoods = flow(function* () {
    try {
      const { data } = yield Serv.getReturnGoods();
    } catch (error) {}
  });
}
const protectionMod = new ProtectionMod();
export default protectionMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Protection/ProtectionMod.js